// Create component map to register decorator
// Decorators are not executed on import statement

import { AptlApp } from "./components/aptl-app/aptl-app.js";
import { TextInput } from "./components/text-input/text-input.js";
import { SubmitButton } from "./components/submit-button/submit-button.js";

export const DEFINE_MAP: any = {
    AptlApp,
    TextInput,
    SubmitButton
}

// Clear body HTML and attach main application component
document.body.innerHTML = "<aptl-app></aptl-app>";